<template>
  <Layout>
    <PageHeader :title="page.title" :items="page.items" />

    <b-card>
      <b-form @submit="onSubmit" @reset="onReset">
        <!-- 加热模式名称 -->
        <b-form-group
          label="Heating Mode Name:"
          label-cols-lg="3"
          label-align-lg="right"
          label-for="heating-name"
          label-class="requiredRow"
        >
          <b-form-input
            id="heating-name"
            v-model="form.modeName"
            placeholder="Please enter 4 to 20 characters"
            trim
            required
            oninvalid="setCustomValidity('Please enter');"
            oninput="setCustomValidity('');"
            onblur="if(value.length<4||value.length>20)value=''"
          ></b-form-input>
        </b-form-group>

        <!-- 所属客户 -->
        <b-form-group
          label="Affiliated Customer:"
          label-cols-lg="3"
          label-align-lg="right"
          label-for="customer"
        >
          <b-form-select
            id="customer"
            v-model="form.supplierId"
            :options="types.allSupplier"
            value-field="id"
            text-field="brandName"
          >
          </b-form-select>
        </b-form-group>

        <!-- 加热模式 -->
        <b-form-group
          label="Heating Mode Type:"
          label-cols-lg="3"
          label-align-lg="right"
          label-for="heatingType"
          label-class="requiredRow"
          style="display: none"
        >
          <b-form-radio-group
            id="heatingType"
            v-model="form.heatingType"
            :options="types.heatingTypes"
            name="heatingType"
            required
            @change.native="changeHeatingType(form.heatingType)"
            style="margin-top: 5px"
          ></b-form-radio-group>
        </b-form-group>

        <!-- 模式描述 -->
        <b-form-group
          label="Heating Mode Description:"
          label-cols-lg="3"
          label-align-lg="right"
          label-for="path"
          label-class="requiredRow"
        >
          <b-form-input
            id="application-name"
            v-model="form.heatingRemarks"
            placeholder="Please enter"
            trim
            required
            oninvalid="setCustomValidity('Please enter');"
            oninput="setCustomValidity('');if(value.length > 100)value = value.slice(0, 100)"
          ></b-form-input>
        </b-form-group>

        <!-- 曲线模式--加热温度设置 -->
        <b-form-group
          v-if="form.heatingType == 2"
          label="Heating Temperature Setting:"
          label-cols-lg="3"
          label-align-lg="right"
          label-for="temperature"
          label-class="requiredRow"
        >
          <!-- <b-form-input
            v-for="(item, index) in temperatureList"
            :key="index"
            class="col-md-1 col-1"
            style="display: inline-block;margin-right:10px;"
            v-model="item.value"
            type="number"
            min="0"
            step="0.01"
            required
            @change="changeTemperatureList(temperatureList)"
            oninvalid="setCustomValidity('Please enter')"
            oninput="setCustomValidity('');value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g,'.').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
            onblur="if(value<200||value>1000)value=''"
          ></b-form-input> -->
          <span
            v-for="(item, index) in temperatureList"
            :key="index"
            class="col-md-2 col-2"
            style="display: inline-block; padding-left: 0"
          >
            <label>{{ index + 1 + " " + "seconds" }}</label>
            <b-form-input
              v-model="item.value"
              type="number"
              min="0"
              step="0.01"
              placeholder="Please enter"
              title=""
              required
              @change="changeTemperatureList(temperatureList)"
              oninvalid="setCustomValidity('Please enter')"
              oninput="setCustomValidity('');value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g,'.').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
              onblur="if(value<200||value>9999)value=''"
            ></b-form-input>
          </span>
          <p>
            The heating temperature is between 200 ℉ and 1000℉. After the 6th
            second, the heating temperature is the same as the 6th second
          </p>
        </b-form-group>

        <!-- 单热模式--加热温度 -->
        <b-form-group
          v-else
          label="Heating Temperature:"
          label-cols-lg="3"
          label-align-lg="right"
          label-for="temperature"
          label-class="requiredRow"
        >
          <b-form-input
            id="temperature"
            v-model="form.temperature"
            placeholder="Please enter(℉)"
            trim
            required
            oninvalid="setCustomValidity('Please enter')"
            oninput="setCustomValidity('');value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g,'.').replace(/^\./g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
          ></b-form-input>
        </b-form-group>

        <!-- 加热图标 -->
        <b-form-group
          label="Heating Mode Photo:"
          label-cols-lg="3"
          label-align-lg="right"
          label-for="logo"
        >
          <input
            type="file"
            class="filestyle"
            data-input="false"
            id="filestyle-1"
            style="position: absolute; clip: rect(0px, 0px, 0px, 0px)"
            tabindex="-1"
            @change="upload($event)"
          />
          <!-- required 
          oninvalid="setCustomValidity('Please upload');"
          oninput="setCustomValidity('');" -->

          <div class="bootstrap-filestyle input-group">
            <div
              name="filedrag"
              style="position: absolute; width: 100%; height: 35px; z-index: -1"
            ></div>
            <span class="group-span-filestyle" tabindex="0">
              <div v-if="form.heatingPhoto" style="margin-bottom: 10px">
                <img
                  :src="form.heatingPhoto"
                  style="width: 100px; height: 100px; border: 2px dashed #ccc"
                />
                <span
                  style="margin-left: 10px; vertical-align: bottom"
                  v-if="!editId"
                >
                  <span style="font-weight: 500">Picture name : </span
                  >{{ photoName }}</span
                >
              </div>
              <label
                for="filestyle-1"
                style="margin-bottom: 0"
                class="btn btn-secondary"
              >
                <span class="buttonText"> upload picture </span>
              </label>
              <span>
                Recommended size of picture: 120 pixels * 120 pixels, supporting
                JPG and PNG formats.
              </span>
            </span>
          </div>
        </b-form-group>

        <!-- 状态 -->
        <b-form-group
          label="Ready for Production - Yes / No:"
          label-cols-lg="3"
          label-align-lg="right"
          label-for="status"
          label-class="requiredRow"
        >
          <b-form-radio-group
            id="radio-group-1"
            v-model="form.status"
            :options="types.statuss"
            name="radio-options"
            required
            style="margin-top: 5px"
          ></b-form-radio-group>
        </b-form-group>

        <!-- 备注 -->
        <b-form-group
          label="Notes:"
          label-cols-lg="3"
          label-align-sm="right"
          label-for="remark"
        >
          <b-form-textarea
            id="remark"
            v-model="form.remarks"
            placeholder="Enter Notes"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group label-cols-lg="3">
          <b-button type="submit" variant="primary">Confirm</b-button>
          <b-button type="reset" variant="danger" class="m-l-5 ml-1"
            >Cancel</b-button
          >
        </b-form-group>
      </b-form>
    </b-card>
  </Layout>
</template>
<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";

import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Multiselect from "vue-multiselect";

import { onReady, upload_img } from "@/api/upload";
import goback from "@/components/goback";

/**
 * FAQ Add component
 */
export default {
  components: {
    Layout,
    PageHeader,
    ckeditor: CKEditor.component,
    Multiselect,
    goback,
  },
  data() {
    return {
      page: {
        title: this.editId ? "Heating Mode Modify" : "Heating Mode Create",
        items: [
          {
            text: "UNI-CORE",
            // href: "/"
          },
          {
            text: "Data Dictionary",
            // href: "/"
          },
          {
            text: this.editId ? "Heating Mode Modify" : "Heating Mode Create",
            active: true,
          },
        ],
      },
      form: {
        id: "",
        modeName: "",
        heatingType: "2",
        heatingRemarks: "",
        supplierId: "",
        heatingPhoto: "",
        temperature: "",
        remarks: "",
        status: 0,
      },
      temperatureList: [
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
      ],
      types: {
        allSupplier: [{ brandName: "Please select", id: "" }],
        heatingTypes: [
          { text: "Consistent Temperature", value: 1 },
          { text: "High Wave", value: 2 },
        ],
        statuss: [
          { text: "Enabled", value: 0 },
          { text: "Disabled", value: 1 },
        ],
      },
      photoName: "",
      editId: window.location.search,
      editor: ClassicEditor,
    };
  },
  beforeCreate() {
    this.editId = window.location.search;
  },
  created() {
    this.init();
    if (this.editId) {
      let id = this.editId.split("=")[1];
      this.formData(id);
    }
  },
  mounted() {},
  methods: {
    onReady: onReady,
    init() {
      this.$api.Dropdown.selectAllSupplier().then((res) => {
        if (res.success && res.data) {
          this.types.allSupplier = this.types.allSupplier.concat(res.data);
        } else {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
        }
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.form.id) {
        this.$api.warmUpMode.updateByHeatingModeId(this.form).then((res) => {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
          if (res.success) {
            this.$router.go(-1);
          }
        });
      } else {
        this.$api.warmUpMode.addHeatingMode(this.form).then((res) => {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
          if (res.success) {
            this.$router.go(-1);
          }
        });
      }
    },
    onReset(evt) {
      evt.preventDefault();
      this.form = {
        id: "",
        modeName: "",
        heatingType: "2",
        heatingRemarks: "",
        supplierId: "",
        heatingPhoto: "",
        temperature: "",
        remarks: "",
        status: "",
      };
      this.$nextTick(() => {
        this.$router.go(-1);
      });
    },
    upload(e) {
      let file = e.target.files[0];
      this.photoName = file.name;
      console.log(file);
      if (/image/.test(file.type)) {
        console.log("uploading", file);
        upload_img(file).then((res) => {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
          if (res.success) {
            this.form.heatingPhoto = res.data;
            console.log("zzzzzzzz", this.form);
          }
        });
      } else {
        e.target.files = [];
        this.$bvToast.toast("only support jpg/png file");
      }
    },
    formData(id) {
      this.$api.warmUpMode.selectByHeatingModeId({ id: id }).then((res) => {
        if (res.success) {
          if (res.data.temperature) {
            let arr = res.data.temperature.split(",");
            this.temperatureList = [];
            arr.forEach((i) => {
              this.temperatureList.push({ value: i });
            });
          }
          this.form = res.data;
        } else {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
        }
      });
    },
    changeTemperatureList(data) {
      let arr = [];
      data.forEach((item) => {
        if (item.value) {
          arr.push(item.value);
        }
      });
      this.form.temperature = arr.join(",");
    },
    changeHeatingType(value) {
      if (value == 2) {
        this.temperatureList = [
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ];
      } else {
        this.form.temperature = "";
      }
    },
  },
};
</script>

<style lang="scss">
.required-icon {
  ::before {
    content: "*";
  }
}
</style>
